import { BrowserRouter, Route, Routes } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import NotFound from "@/pages/NotFound";
import FrontendMasterLayout from "@/pages/frontend/masterLayout/MasterLayout";
import Home from "@/pages/frontend/page";
import PricingPage from "@/pages/pricing/page";
import AdvertisePage from "@/pages/advertise/page";
import DocsPage from "@/pages/docs/page";
import AuthPage from "@/pages/auth/AuthPage";
import AccountPage from "@/pages/auth/AccountPage";
import PasswordRecoveryPage from "@/pages/auth/PasswordRecoveryPage";
import PolicyPage from "@/pages/auth/PolicyPage";
import DashboardRouteGuard from "@/pages/auth/DashboardRouteGuard";

import DashboardMasterLayout from "@/pages/dashboard/masterLayout/MasterLayout";
import DashboardOverview from "@/pages/dashboard/page";
import MembersPage from "@/pages/dashboard/members/page";
import TransactionsPage from "@/pages/dashboard/transactions/page";
import RewardsPage from "@/pages/dashboard/rewards/page";
import RedemptionsPage from "@/pages/dashboard/redemptions/page";
import SponsorsPage from "@/pages/dashboard/sponsors/page";
import IntegrationsPage from "@/pages/dashboard/integrations/page";
import SettingsPage from "@/pages/dashboard/settings/page";

import SponsorLayout from "@/pages/sponsor/layout";
import SponsorPlansPage from "@/pages/sponsor/page";
import SponsorRegisterPage from "@/pages/sponsor/register/page";
import SponsorCheckoutPage from "@/pages/sponsor/checkout/page";
import SponsorDonePage from "@/pages/sponsor/done/page";
import SponsorDashboardPage from "@/pages/sponsor/dashboard/page";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Routes>
          {/* Public website: frontend MasterLayout adds the header and footer. */}
          <Route element={<FrontendMasterLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/advertise" element={<AdvertisePage />} />
          </Route>

          {/* Pages with their own full-screen design. */}
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/login" element={<AuthPage initialMode="login" />} />
          <Route path="/signup" element={<AuthPage initialMode="signup" />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/forgot-password" element={<PasswordRecoveryPage />} />
          <Route path="/terms" element={<PolicyPage />} />
          <Route path="/privacy" element={<PolicyPage />} />

          {/* Sponsor onboarding flow. */}
          <Route path="/sponsor" element={<SponsorLayout />}>
            <Route index element={<SponsorPlansPage />} />
            <Route path="register" element={<SponsorRegisterPage />} />
            <Route path="checkout" element={<SponsorCheckoutPage />} />
            <Route path="done" element={<SponsorDonePage />} />
            <Route path="dashboard" element={<SponsorDashboardPage />} />
          </Route>

          {/* Dashboard: dashboard MasterLayout adds the sidebar, header and footer. */}
          <Route path="/dashboard" element={<DashboardRouteGuard><DashboardMasterLayout /></DashboardRouteGuard>}>
            <Route index element={<DashboardOverview />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="rewards" element={<RewardsPage />} />
            <Route path="redemptions" element={<RedemptionsPage />} />
            <Route path="sponsors" element={<SponsorsPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
